import type { CustomBackgroundTemplateBox } from '@lite-workspace/dto-fotoclass-templates';
import type { DrawableBackgroundData } from '../interfaces/drawable-data.interface';
import { decode as decodeBackgroundBox, encode as encodeBackgroundBox } from './boxes/background-box';
import type { NormalizerContext } from './boxes/codec-contract';

/** One shared codepath for cover AND regular spreads — no branch can read/write background on one but not the other. */
export function encodeSpreadBackground(
  background: DrawableBackgroundData | undefined,
  ctx: NormalizerContext,
): CustomBackgroundTemplateBox | undefined {
  if (!background) return undefined;
  return encodeBackgroundBox(background, ctx);
}

export function decodeSpreadBackground(
  background: CustomBackgroundTemplateBox | undefined,
  ctx: NormalizerContext,
): DrawableBackgroundData | undefined {
  if (!background) return undefined;
  return decodeBackgroundBox(background, ctx);
}
